export enum ErrorMessageDirection {
  TOP_BOTTOM = 'TOP_BOTTOM',
  RIGHT_LEFT = 'RIGHT_LEFT',
  BOTTOM_TOP = 'BOTTOM_TOP',
  LEFT_RIGHT = 'LEFT_RIGHT',
  NONE = 'NONE'
}
